type Props = {
  className?: string;
  glow?: boolean;
};

/**
 * 鳥居 SVG (placeholder — assets/ から本素材到着まで)。
 * ピクセルパーフェクトでなく、シルエットの存在感を優先。
 */
export function Torii({ className, glow }: Props) {
  return (
    <svg
      viewBox="0 0 240 200"
      className={className}
      aria-hidden
      style={{
        filter: glow ? "drop-shadow(0 0 32px rgba(159,29,53,0.7))" : undefined,
      }}
    >
      <defs>
        <linearGradient id="torii-shu" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#c43a55" />
          <stop offset="100%" stopColor="#6b1024" />
        </linearGradient>
      </defs>
      {/* 笠木 (top beam) */}
      <path
        d="M 10 36 Q 120 12 230 36 L 226 50 Q 120 28 14 50 Z"
        fill="url(#torii-shu)"
      />
      {/* 島木 (second beam) */}
      <rect x="22" y="56" width="196" height="14" fill="url(#torii-shu)" />
      {/* 貫 (cross beam) */}
      <rect x="36" y="92" width="168" height="10" fill="url(#torii-shu)" />
      {/* 額束 (center plate) */}
      <rect x="110" y="70" width="20" height="22" fill="#1a1a1a" />
      {/* 柱 left */}
      <path d="M 44 56 L 50 56 L 56 192 L 38 192 Z" fill="url(#torii-shu)" />
      {/* 柱 right */}
      <path d="M 190 56 L 196 56 L 202 192 L 184 192 Z" fill="url(#torii-shu)" />
    </svg>
  );
}
